import { render, staticRenderFns } from "./SentencesMenu.vue?vue&type=template&id=320be1be&"
import script from "./SentencesMenu.vue?vue&type=script&lang=js&"
export * from "./SentencesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports